import React from "react";
import PropTypes from "prop-types";
import Table from "../../../common/components/Table/Table";
import lodash from "lodash/core";
import _ from "lodash";

export default class VerifiableElementsTable extends React.Component {

    static propTypes = {
        sourceDetail: PropTypes.object,
        dpInputFields: PropTypes.array,
    }

    get tableHeaders() {
        return [
            <Table.Header key="type">Type</Table.Header>,
            <Table.Header key="element">Element</Table.Header>,
            <Table.Header key="result-type">Result Type</Table.Header>
        ];
    }

    // this is the legacy veritas way of doing things, and can be revisited if necessary
    resultType = (labelType) => {
        const resultType = _.isEmpty(this.props.sourceDetail)
            ? []
            : this.props.sourceDetail.verifiable_inputs;

        return (
            <td>{resultType
                ? (labelType.map((label,idx) => {
                    let resultElement = null;
                        if (label.scores) {
                            resultElement = (<span key={idx}>Scores<br/></span>)
                        } else if(label.candidate_records) {
                            resultElement =  (<span key={idx}>Candidate Records<br/></span>)
                        }
                        return resultElement;
                    })
                )
                : null}
            </td>
        )
    }

    get nameRow() {
        const nameLabels = lodash.filter(this.props.sourceDetail.verifiable_inputs,
            ({label_id}) => label_id <= 5);

        if(nameLabels.length > 0){
            nameLabels.sort(((a, b) => {return a.label_id - b.label_id}))

            return (
                <tr>
                    <td>
                        <span>Name</span>
                    </td>
                    <td>{nameLabels
                        ? (nameLabels.map(label => {
                            return (<span key={label.label_id}>{label.label_name}<br/></span>)
                        }))
                        : null
                    }</td>
                    {this.resultType(nameLabels)}
                </tr>
            );
        } else{ return null }
    }

    get addressRow() {
        const addressLabels = lodash.filter(this.props.sourceDetail.verifiable_inputs,
            ({label_id}) => label_id >=6 && label_id <=16 );

        if(addressLabels.length > 0) {
            addressLabels.sort(((a, b) => {return a.label_id - b.label_id}))

            return (
                <tr>
                    <td>
                        <span>Address</span>
                    </td>
                    <td>{addressLabels
                        ? (addressLabels.map(label => {
                            return (<span key={label.label_id}>{label.label_name}<br/></span>)
                        }))
                        : null
                    }</td>
                    {this.resultType(addressLabels)}
                </tr>
            );
        } else { return null }
    }

    get IDRow() {
        const IDLabels = lodash.filter(this.props.sourceDetail.verifiable_inputs,
            ({label_id}) => label_id >=17 && label_id <=23 );

        if(IDLabels.length){
            IDLabels.sort(((a, b) => {return a.label_id - b.label_id}))

            return (
                <tr>
                    <td>
                        <span>ID</span>
                    </td>
                    <td>{IDLabels
                        ? (IDLabels.map(label => {
                            return (<span key={label.label_id}>{label.label_name}<br/></span>)
                        }))
                        : null
                    }</td>
                    {this.resultType(IDLabels)}
                </tr>
            );
        } else{ return null }
    }

    // this will be only rendered for sources associated with KYB-type services.
    get businessRow() {
        const businessLabels = lodash.filter(this.props.sourceDetail.verifiable_inputs,
            ({label_id}) => label_id >=24 && label_id <=33 );
        if(businessLabels.length) {
            businessLabels.sort(((a, b) => {return a.label_id - b.label_id}))

            return (
                <tr>
                    <td>
                        <span>Business</span>
                    </td>
                    <td>{businessLabels
                        ? (businessLabels.map(label => {
                            return (<span key={label.label_id}>{label.label_name}<br/></span>)
                        }))
                        : null
                    }</td>
                    {this.resultType(businessLabels)}
                </tr>
            );
        } else { return null }
    }

    render() {

        return(
            <div className="source-detail-table">
                <h2>Verifiable Elements</h2>
                <Table headers={this.tableHeaders}>
                    {this.nameRow}
                    {this.addressRow}
                    {this.IDRow}
                    {this.businessRow}
                </Table>
            </div>
        );
    }
}

